
const AchatChoiceForm = function(element) {
    this.element = $(element);
    this.form = this.element.closest('form');

    this.agence = this.form.find('[name$="\[agence\]"]');
    this.fournisseur = this.form.find('[name$="\[fournisseur\]"]');

    this.agence.on('change', $.proxy(this.resetValue, this));
    this.fournisseur.on('change', $.proxy(this.resetValue, this));

    this.element.select2({
        ajax: {
            url: this.element.attr('data-url'),
            dataType: 'json',
            data: params => {
                return {
                    search: params.term,
                    page: params.page || 1,
                    filter_form_achat: this.getFilterFormParams()
                }
            },
            processResults: response => {
                const results = [];

                $.each(response.data, (index, achat) => {
                    const text = achat.numero + ' (' + achat.fournisseur.labelTiers + ')';

                    results.push({
                        id: achat.id,
                        text: text
                    });
                });

                return {
                    results: results,
                    pagination: {
                        more: response.page < response.pages
                    }
                }
            }
        }
    });
}

$.extend(AchatChoiceForm.prototype, {
    resetValue: function() {
        this.element.val(null).trigger('change');
    },

    getFilterFormParams: function() {
        const params = {
            type: 'facture'
        };

        if (this.agence.length) {
            params.agence = this.agence.val();
        }

        if (this.fournisseur.length) {
            params.fournisseur = this.fournisseur.val();
        }

        return params;
    }
});

const achatChoiceForm = () => {
    const selector = 'select[data-achat-choice]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new AchatChoiceForm(this);
    });
};

export { achatChoiceForm }


// WEBPACK FOOTER //
// ./js/form/achatChoice.js